import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, from, Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { User } from '../models/user';
import { environment } from 'src/environments/environment';

import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
// import firebase from 'firebase/app';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(
    private _fireBaseAuth: AngularFireAuth,
    private _fireStore: AngularFirestore,
    private _http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(username: string, password: string) {
    return from(this._fireBaseAuth.signInWithEmailAndPassword(username, password)).pipe(
      switchMap(((fireUser: any) => {
        const userObj: User = {
          token: fireUser.user.refreshToken,
          username: fireUser.user.email,
          id: fireUser.user.uid,
          password: '',
          firstName: '',
          lastName: ''
        }
        return this._fireStore
          .collection<User>('users')
          .doc(fireUser.user.email)
          .valueChanges()
          .pipe(
            map((user) => {
              userObj.firstName = user.firstName;
              userObj.lastName = user.lastName;

              localStorage.setItem('currentUser', JSON.stringify(userObj));
              this.currentUserSubject.next(userObj);
              console.log(userObj);
              return userObj;
            }));
      }
      )));
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
    this._fireBaseAuth.signOut();
    return of({ success: false });
  }
}
